export class CountAggregator {
    constructor(field) {
        this._type = 'count';
        this._field = field;
    }
    get field() {
        return this._field;
    }
    get type() {
        return this._type;
    }
    init() {
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals[this._type] === undefined) {
            groupTotals[this._type] = {};
        }
        groupTotals[this._type][this._field] = groupTotals.group.rows.length;
    }
}
//# sourceMappingURL=countAggregator.js.map